
export const aboutData = {
    title: "Who I am",
    description1: "My name is Sudhanshu, and I have 3.3 years of experience working with MERN stack (React/Node.js) and Python/Django.",
    description2: "I am eager for opportunities to expand my skill set and drive company growth in a Backend or MERN Full stack development role. My passion for learning and commitment to delivering high-quality work make me a valuable addition to any team.",
    image: 1
}